<main class="logout-page container-fluid py-5" aria-label="Logout">
  <div class="container-lg">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8">
        <div class="card shadow-sm logout-card">
          <div class="card-body p-5 text-center">
            <!-- Success Icon -->
            <div class="logout-icon-container mb-4">
              <mat-icon class="logout-icon">check_circle</mat-icon>
            </div>
            
            <!-- Title -->
            <h1 class="h3 fw-bold mb-3">Successfully Logged Out</h1>
            
            <!-- Message -->
            <p class="text-muted mb-4">
              You have been successfully logged out from the application.
            </p>
            
            <!-- Login Again Button -->
            <div>
              <button class="button" (click)="redirectToLogin()">
                Login Again
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
